import { handlePartnerFlowInitialData } from '@Services/init/flow-identifier-service/partner.service.ts';
import { handleAuthUserFlowInitialData } from '@Services/init/flow-identifier-service/authUserOnboarding.service.ts';

interface IParams {
  partnerToken: string;
  referralCode: string;
  customerKey: string;
  sourcePlatform: string;
  customerId: string;
  authorizedUserId: string;
}

export const flowIdentifierService = async ({
  partnerToken,
  authorizedUserId,
  customerId,
  customerKey,
  sourcePlatform,
  referralCode,
}: IParams) => {
  console.log({
    partnerToken,
    authorizedUserId,
    customerId,
    customerKey,
    sourcePlatform,
    referralCode,
  });
  if (partnerToken) {
    await handlePartnerFlowInitialData(partnerToken);
  } else if (customerId && authorizedUserId) {
    await handleAuthUserFlowInitialData(customerId, authorizedUserId);
  }
};
